export const LOGIN_URL = "api/v1/admin/login";
export const GET_USERS_URL = "api/v1/user/search";
export const GET_PROFILE = "api/v1/pharmacy-user/profile";
export const UPDATE_PROFILE = "api/v1/pharmacy-user/profile";
export const UPDATE_PASSWORD = "api/v1/pharmacy-user/change-password";

export const GET_BOOKING_STATS_URL = "api/v1/lab-test-booking/admin-dashboard";
export const GET_ADMIN_TEST_RESULTS_TABLE = "api/v1/lab-test-booking/admin/test-results-table";
export const EXPORT_ADMIN_TEST_RESULTS_CSV = "api/v1/lab-test-booking/admin/test-results-table/export";
export const GET_CONTACT_SUBMISSIONS = "api/v1/contact";
export const GET_EMPLOYEE_DASHBOARD_DATA = "api/v1/lab-test-booking/employee-dashboard/:pharmacyId";
export const GET_PHARMACY_LEADERBOARD_ADMIN_URL = "api/v1/pharmacy/admin/leaderboard";
export const LEADERBOARD_VIEWER_LOGIN_URL = "api/v1/admin/leaderboard-viewer/login";

export const GET_PHARMACY_TEST_LIST = "api/v1/labtest/all";
export const GET_DNA_LIST = "api/v1/dna/list";
export const GET_DNA_SAMPLE_DETAILS = "api/v1/dna/sample";
export const UPLOAD_DNA_RESULT = "api/v1/dna";
export const RESEND_DNA_EMAIL = "api/v1/dna";
export const GET_TUTORIALS = "api/v1/tutorials";
export const GET_BOOKING_LIST = "api/v1/lab-test-booking/:pharmacyId/all";
export const CREATE_BOOKING = "api/v1/lab-test-booking/multiple";
export const CANCEL_BOOKING = "api/v1/lab-test-booking";

export const GET_PHARMACY_TEAM_LIST = "api/v1/pharmacy-user";
export const PHARMACY_LIST = "api/v1/pharmacy/list";

export const GET_PHARMACY_DETAILS = "api/v1/pharmacy/details";

export const UPDATE_PHARMACY_DETAILS = "api/v1/pharmacy";

export const ADD_LAB_TEST = "api/v1/labtest";
export const ADD_LAB_TEST_PACKAGE = "api/v1/labtest/package";
export const DELETE_LAB_TEST = "api/v1/pharmacy-test";

export const GET_LAB_TEST_LIST = "api/v1/labtest";

export const GET_LABCLINIC_ANALYSES = "api/v1/labclinic/analyses";

export const CREATE_PHARMACY_USER = "api/v1/pharmacy-user/register";

export const DELETE_PHARMACY_USER = "api/v1/pharmacy-user";